import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function IconImagemap({
  className,
  width,
  height,
  id,
  color,
  hoverColor,
  viewBox,
}) {
  const [mainColor, setMainColor] = useState(color);

  useEffect(() => {
    if (color !== mainColor) {
      setMainColor(color);
    }
  }, [color]);

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
    >
      <defs>
        <path
          id="icon-imagemap"
          d="M17 3.2A3.8 3.8 0 0 1 20.8 7v10l-.002.117a.805.805 0 0 1-.01.195A3.801 3.801 0 0 1 17 20.8H7a3.8 3.8 0 0 1-3.787-3.488.774.774 0 0 1-.011-.192A4.077 4.077 0 0 1 3.2 17V7A3.8 3.8 0 0 1 7 3.2h10zm-7.842 9.363a.2.2 0 0 0-.282.025L4.84 17.415A2.2 2.2 0 0 0 7 19.2h10a2.2 2.2 0 0 0 2.153-1.746l-3.662-3.72-.008-.007a.2.2 0 0 0-.282.013l-1.937 2.13a.8.8 0 0 1-1.192-.008L9.18 12.584a.2.2 0 0 0-.022-.021zM17 4.8H7A2.2 2.2 0 0 0 4.8 7v7.968l2.849-3.406a1.8 1.8 0 0 1 2.405-.326l.13.1a1.8 1.8 0 0 1 .196.19l2.3 2.607 1.337-1.469a1.8 1.8 0 0 1 2.614-.052L19.2 15.22V7A2.2 2.2 0 0 0 17 4.8zm-1.5 1.4a2.3 2.3 0 1 1 0 4.6 2.3 2.3 0 0 1 0-4.6zm0 1.6a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M-24-10h228v44H-24z" />
        <g>
          <path d="M0 0h24v24H0z" />
          <mask id={id} fill="#fff">
            <use xlinkHref="#icon-imagemap" />
          </mask>
          <g fill={mainColor} mask={`url(#${id})`}>
            <path d="M0 0h24v24H0z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

IconImagemap.defaultProps = {
  className: undefined,
  width: 24,
  height: 24,
  color: '#BDBDBD',
  hoverColor: '#fff',
  viewBox: '0,0,24,24',
  id: undefined,
};

IconImagemap.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
};

export default IconImagemap;
